import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FieldProps } from "react-jsonschema-form";
import SelectGroup from "../../witadmin/CRUD/Common/SelectGroup";
import styled from "styled-components";
import {
  GetLoyaltyTiersByBrandRequest,
  LoyaltyConstantTier,
  LoyaltyDerivedTier,
} from "../../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_pb";
import { useGrpcClient } from "../../../lib/grpc";
import { LoyaltyTierAPIPromiseClient } from "../../../gen/witbooking/backoffice/loyalty/tier/v1/loyalty_tier_api_grpc_web_pb";
import { useLoyaltyBrand } from "../../../components/loyalty-brand-provider";

const SelectGroupWrapper = styled.div`
  display: flex;
  max-width: 200px;
  margin-bottom: -20px;
`;

export function LoyaltyTierSelector({
  formData,
  onChange,
  rawErrors,
  disabled,
  id,
  schema
}: FieldProps) {
  const brand = useLoyaltyBrand()?.ticker || "";

  const [allTiers, setAllTiers] = useState<
    (LoyaltyConstantTier.AsObject | LoyaltyDerivedTier.AsObject | undefined)[] | undefined
  >();
  const tierClient = useGrpcClient(LoyaltyTierAPIPromiseClient);

  useEffect(() => {
    const asyncFun = async () => {
      if (!allTiers) {
        const request = new GetLoyaltyTiersByBrandRequest();
        request.setBrandTicker(brand);
        const response = await tierClient.getLoyaltyTiersByBrand(request);
        if (response) {
          const res = response.toObject();
          setAllTiers(
            res.tiersList.map(it => (it.constantTier ? it.constantTier : it.derivedTier))
          );
        }
      }
    };
    asyncFun();
  }, [allTiers, tierClient, brand]);

  const tiersOptions = useMemo(() => {
    if (allTiers?.length) {
      return allTiers.reduce(
        (accum, curr) => {
          if (curr) {
            return {
              [curr.externalSystemId]: { label: curr.ticker },
              ...accum,
            };
          } else {
            return accum;
          }
        },
        { unset: { label: "" } }
      );
    }
    return {};
  }, [allTiers]);
  const handleChange = useCallback(
    event => onChange(event.target.value),
    [onChange]
  );
  return (
    <>
      <label>{schema?.title}</label>
      <SelectGroupWrapper>
        <SelectGroup
          value={formData || "unset"}
          field={{
            fieldName: "type",
            widget: "selector",
            optionDisplay: tiersOptions,
          }}
          onChange={({ event, field }) => handleChange(event)}
          errors={undefined}
          additionalFields={undefined}
          className={undefined}
        />
      </SelectGroupWrapper>
    </>
  );
}
